import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CadastroFossaSeptica from './CadastroFossaSeptica';

/**
 * Componente wrapper para o CadastroFossaSeptica que lida com a navegação
 */
const CadastroFossaSepticaWrapper = () => {
  const { residenciaId } = useParams();
  const navigate = useNavigate();

  // Função para fechar o formulário e voltar para a página anterior
  const handleClose = () => {
    // Voltar para a página anterior
    navigate(-1);
  };

  // Função para salvar a fossa e voltar para a página anterior
  const handleSave = () => {
    // Voltar para a página anterior após salvar
    navigate(-1);
  };

  return (
    <CadastroFossaSeptica 
      residenciaId={residenciaId}
      onClose={handleClose}
      onSave={handleSave}
    />
  );
};

export default CadastroFossaSepticaWrapper;